import { checkoutWidgetsSchema } from "@redotech/redo-model/checkouts/checkout-widgets-builder";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateCheckoutExperienceWidgets = {
  name: "updateCheckoutExperienceWidgets" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    checkoutWidgets: checkoutWidgetsSchema,
  }),
  output: z.null(),
};
